import { useCallback, useEffect, useState } from "react"
import { usePagination } from "../../hooks/usePagination"
import ApiService from "../../services/apiService"
import { method } from "lodash"
import { format } from "date-fns"
import RightIcon from "../svg/RightIcon"
import LeftIcon from "../svg/LeftButton"
import { Button, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Label } from "reactstrap"
import DateTimePicker from 'react-datepicker'
import Breadcrumbs from "../../coreComponents/breadcrumbs"
import Table from "../table/Table";
import { useNavigate } from "react-router-dom"
import ExportExcel from "../reports/ExportExcel"
import { toast } from "react-toastify"


const WuaWiseSummary =() =>{

    const [fromDateTime,setFromDateTime] = useState<any>()
    const [toDateTime,  setToDateTime] = useState<any>()
    const [wuas, setwuas] = useState<any>()
    const [selectedWuas,setselectedWuas] =useState<any>()
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
    const [unitPrice,setUnitPrice] = useState()
    const navigate = useNavigate();
    const [enabled,setEnabled] = useState<boolean>(false)
  const [allWuaId,setAllWuaId] = useState<string|number>()
  const [refreshKey, setRefreshKey] = useState(0);
    const {
        data,
        totalCount,setFromDate,
        setToDate,pageNumber,
        setPageNumber,pageSize,
        setSchemeVillageId,fromDate,
        setWauId,
        toDate,
        

    } = usePagination({
        endpoint:`/wuareport/getreportbydateandid` ,
        enabled:enabled,
        refreshKey
    })

    const totalPages = Math.ceil(totalCount / pageSize);

    const handleNext = useCallback(() => {
        setPageNumber((prev) => Math.min(totalPages, prev + 1))
    }, [setPageNumber, totalPages])



    const handlePrev = useCallback(() => {
        setPageNumber((prev) => Math.max(1, prev - 1))
    }, [setPageNumber, totalPages])

    const handleClick = () =>{
        if (!validateGenerate()) return;
        if(fromDateTime){
             const from = format(fromDateTime, 'yyyy-MM-dd HH:mm:ss');
             setFromDate(from);
        }
        if(toDateTime){
             const to = format(toDateTime, 'yyyy-MM-dd HH:mm:ss');
             setToDate(to);
        }
        setEnabled(true);
        setRefreshKey(prev => prev + 1); // Force API re-fetch
        setPageNumber(1); 
    }
    useEffect(()=>{
          getWua();
    },[])

      const getWua  = async() =>{
         try{
             const response = await ApiService.axiosApi(`/wua`,{
                 method:'GET',
                 params:{
                    pageNumber:0,
                    pageSize:0
                 }
                 

             })
             if(response.success){
                 setwuas(response.data.data)
             }else{
                 console.log('unable to get wua')
             }
         }catch(e){
             console.log('unable to get wua',e)
         }
      }

     const fectWuaReport = async() =>{
         
        try{
             const response = await ApiService.axiosApi(`/wuareport/getreportbydateandid`,{
                 method:'GET',
                 params:{
                     WuaId:allWuaId,
                     pageNumber:0,
                     pageSize:0,
                     FromDate:format(fromDateTime, 'yyyy-MM-dd HH:mm:ss'),
                     ToDate:format(toDateTime, 'yyyy-MM-dd HH:mm:ss')

                 }
             })

             if(response.success){
                 return response.data.data
             }else{
                 console.log("uanable to get wua report")
             }
        }catch(e){
             console.log(e)
        }
         
     }
     const validateGenerate = () => {
        if (!selectedWuas) {
            toast.warning("Please select Wua");
            return false;
          }
            
          
        if (!fromDateTime) {
          toast.warning("Please select From Date");
          return false;
        }
      
        if (!toDateTime) {
          toast.warning("Please select To Date");
          return false;
        }
      
        if (new Date(fromDateTime) > new Date(toDateTime)) {
          toast.warning("From Date cannot be greater than To Date");
          return false;
        }
      
        return true;
      };

      
      
      
    return(
         <>
           <Breadcrumbs mainTitle="WUA Wise Water Distribution" parent="WUA Report" />
            <div className='w-100 bg-white px-2 py-2'>
                <div className='bg-light-primary d-flex justify-content-around align-items-center'
                    style={{
                        width: '100%',
                        height: '100px',
                        border: '1px solid rgb(43, 94, 94, 0.1)',
                    }}>

                    <div className="d-flex flex-column">
                        <Label>WUAs:</Label>

                        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} className="custom-dropdown-wrapper">
                            <DropdownToggle
                                className="custom-dropdown-toggle d-flex align-items-center justify-content-between report-dropdown"

                                style={{
                                    
                                    fontWeight: 500,
                                    borderRadius: '5px',
                                    padding: '8px 16px',
                                    width: '200px',
                                    height: '36px'
                                }}
                                color="whitesmoke"
                            >
                                {selectedWuas ? selectedWuas : "WUA"}
                            </DropdownToggle>

                            <DropdownMenu
                                className="custom-dropdown-menu"
                                style={{

                                    overflowY: 'auto',
                                    boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.1)',
                                    borderRadius: '8px',
                                    padding: '8px 0',
                                }}
                            >
                                {wuas?.map((data: any) => (
                                    <DropdownItem onClick={() => {
                                        setWauId(data.id)
                                        setAllWuaId(data.id)
                                        setselectedWuas(data.headQuaterName)
                                    }} key={data.id}>
                                        {data.headQuaterName}
                                    </DropdownItem>
                                ))}
                            </DropdownMenu>
                        </Dropdown>

                    </div>

                    <div className="report-input-div mx-4 input-border d-flex flex-column ">
                        <Label>From Date:</Label>
                        <DateTimePicker
                            className="report-input"
                            dateFormat="dd/MM/yyyy"
                            placeholderText="DD-MM-YYYY"
                          
                            onChange={(date: any) => setFromDateTime(date)}
                            selected={fromDateTime}
                            isClearable
                       
                        />
                    </div>


                    <div className="report-input-div mx-4  input-border  d-flex flex-column">
                        <Label>To Date:</Label>
                        <DateTimePicker
                            className="report-input"
                            dateFormat="dd/MM/yyyy"
                            placeholderText="DD-MM-YYYY"
                           
                            onChange={(date: any) => setToDateTime(date)}
                            selected={toDateTime}
                            isClearable
                           
                        />
                    </div>

                    <div className=" d-flex flex-column"style={{width:'8%'}} >
                        <Label style={{ visibility: 'hidden' }}>Generate</Label>
                        <Button className="px-0" color="success" onClick={handleClick}style={{
                 width:'100%', whiteSpace: 'nowrap',
                 overflow: 'hidden',
                 textOverflow: 'ellipsis' 
            }}>
                            Generate
                        </Button>
                    </div>
                     
                     <div style={{width:'8%'}}>
                     <Label style={{ visibility: 'hidden' }}>Generate</Label>
                        <ExportExcel
                          getData={fectWuaReport}
                         toDate={toDate}
                         fileName='Wua_Water_Distribution_Report'
                         unitPrice={unitPrice}
                         EffectiveFrom={fromDate}
                         selectedChakScheme={selectedWuas}
                         hiddenColumns={['id','schemeVillage','wuaId']}
                        
                        
                        
                         columnHeaderMap={{
                           
                            chak:'chakName',
                            Wua:'headQuaterName',
                            totalWaterDischargeInleters:'totalWaterDistrubuted',
                            TotalAreaCoverd:"chakArea"
                            
                          }}
                          columnOrder={['chakName','headQuaterName','chakArea','totalWaterDistrubuted']}
                        />
                     </div>
                    
                    
                </div>


                <div className='mt-2'>
                  <Table
                        isAction={false}
                        data={data}
                        columns={[
                            {header:'Chak',accessor:'chakName'},  
                { header: "WUA", accessor: "headQuaterName" },
                { header: "Total Area(HA)", accessor: "chakArea" },
                {
                  header: "Total Water Distributed(m³)",
                  accessor: "totalWaterDistrubuted",
                },
                
                            
                           ]}

                        buttons={[
                           
                        ]}
                    />  {(!data || data.length === 0) && (
    <div className="d-flex justify-content-center py-3 text-muted">
        No data available
    </div>
)}

                    <div className=" d-flex justify-content-end align-content-center" style={{ marginRight: '10px', marginTop: '10px' }}>
                        <p style={{ marginRight: '10px', marginTop: '8px' }}>
                            Page {pageNumber} of {totalPages}
                        </p>
                        <button
                            onClick={handlePrev}
                            disabled={pageNumber === 1}
                            className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                        >
                            <LeftIcon className="icon" />
                        </button>
                        <button
                            className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                            onClick={handleNext}
                            disabled={pageNumber === totalPages}
                        >
                            <RightIcon className="icon" />
                        </button>
                    </div>
                </div>

            </div>
         </>
    )
}

export default WuaWiseSummary